<template>
    <canvas />
</template>

<script>
import anime from 'animejs/lib/anime.es.js'

export default {
    mounted() {

        const tap = ('ontouchstart' in window || navigator.msMaxTouchPoints) ? 'touchstart' : 'mousedown',
            canvas = this.$el,
            ctx = canvas.getContext('2d'),
            numberOfParticles = 24,
            distance = 200,
            coords = {
                x: 0,
                y: 0
            },
            animations = [],
            colors = ['#FF324A', '#31FFA6', '#206EFF', '#FFFF99']

        function getFontSize() {
            return parseFloat(getComputedStyle(document.documentElement).fontSize)
        }

        function setCanvasSize() {
            canvas.width = window.innerWidth
            canvas.height = window.innerHeight
        }

        function updateCoords(e) {
            coords.x = e.clientX || e.touches[0].clientX
            coords.y = e.clientY || e.touches[0].clientY
        }

        function randomInitFromRange(min, max) {
            return Math.floor(Math.random() * (max - min + 1) + min)
        }

        function removeAnimation(animation) {
            let index = animations.indexOf(animation)
            index > -1 ? animations.splice(index, 1) : ''
        }

        class Circle {
            constructor(x, y) {
                this.x = x
                this.y = y
                this.color = colors[randomInitFromRange(0, (colors.length -1))]
                this.radius = 0
                this.alpha = 1
                this.lineWidth = 6
            }

            draw() {
                ctx.globalAlpha = this.alpha
                ctx.beginPath()
                ctx.arc(this.x, this.y, this.radius, 0, 2 * Math.PI, true)
                ctx.lineWidth = this.lineWidth
                ctx.strokeStyle = this.color
                ctx.stroke()
                ctx.globalAlpha = 1
            }

        }

        class Particle {
            constructor(x, y) {
                this.x = x
                this.y = y
                this.color = colors[randomInitFromRange(0, (colors.length -1))]
                this.radius = randomInitFromRange(getFontSize(), getFontSize() * 2)
            }

            draw() {
                ctx.beginPath()
                ctx.arc(this.x, this.y, this.radius, 0, 2 * Math.PI, true)
                ctx.fillStyle = this.color
                ctx.fill()
            }
        }

        function generateParticles(x, y) {
            let particles = []

            for (let i=0; i < numberOfParticles; i++) {
                let p = new Particle(x, y)

                particles.push(p)
            }

            return particles
        }

        function generateAnimations(x, y) {
            setCanvasSize()

            const particles = generateParticles(x, y),
                circle = new Circle(x, y),
                particlesAnimation = anime({
                    targets: particles,
                    x: (p) => p.x + anime.random(-distance, distance),
                    y: (p) => p.y + anime.random(-distance, distance),
                    radius: 0,
                    duration: () => anime.random(1200, 1800),
                    easing: 'easeOutExpo',
                    complete: removeAnimation
                }),
                circleAnimation = anime({
                    targets: circle,
                    radius: () => anime.random(getFontSize() * 8.75, getFontSize() * 11.25),
                    lineWidth: 0,
                    alpha: {
                        value: 0,
                        easing: 'linear',
                        duration: () => anime.random(400, 600)
                    },
                    duration: () => anime.random(1200, 1800),
                    easing: 'easeOutExpo',
                    complete: removeAnimation
                })

            animations.push(particlesAnimation)
            animations.push(circleAnimation)
        }


        // eslint-disable-next-line
        const animation = anime({
            duration: Infinity,
            update: () => {
                ctx.clearRect(0, 0, canvas.width, canvas.height);
                animations.forEach(function (animation) {
                    animation.animatables.forEach(function (animatable) {
                        animatable.target.draw();
                    });
                });
            }
        })

        document.addEventListener(tap, e => {
            updateCoords(e)
            generateAnimations(coords.x, coords.y)
        }, false)

        window.addEventListener('resize', setCanvasSize(), false)

        updateCoords({
            clientX: window.innerWidth / 2,
            clientY: window.innerHeight / 2
        })

        generateAnimations(coords.x, coords.y)

        setCanvasSize()

        var timing = null

        timing = setInterval(() => {
            generateAnimations(randomInitFromRange(0, window.innerWidth), randomInitFromRange(0, window.innerHeight))
        }, 4000);

        // window.addEventListener('focus', () => {
        //     timing = setInterval(() => {
        //         generateAnimations(randomInitFromRange(0, window.innerWidth), randomInitFromRange(0, window.innerHeight))
        //     }, 4000);
        // })

        // window.addEventListener('blur', () => {
        //     clearInterval(timing);
        // })

        document.addEventListener('visibilitychange', function(){

            if (!document.hidden) {
               timing = setInterval(() => {
                    generateAnimations(randomInitFromRange(0, window.innerWidth), randomInitFromRange(0, window.innerHeight))
                }, 4000);
            } else {
                clearInterval(timing);
            }
        })

        return {
            boom: generateAnimations
        }
    }
}
</script>

<style lang="sass">
canvas
    position: absolute
    top: 0
    left: 0
    z-index: -1
    width: 100%
    height: 100%
    background: #141E30
    background: -webkit-linear-gradient(to left top, #243B55, #141E30)
    background: linear-gradient(to left top, #243B55, #141E30)


</style>